/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllHerdsForOfflineQueryResponse, ListAllHerdsForOfflinePathParams, ListAllHerdsForOfflineQueryParams, ListAllHerdsForOffline400, ListAllHerdsForOffline401, ListAllHerdsForOffline403, ListAllHerdsForOffline404, ListAllHerdsForOffline409, ListAllHerdsForOffline500 } from "../../types/livestockController/ListAllHerdsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllHerdsForOffline } from "../../client/livestockController/listAllHerdsForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllHerdsForOfflineQueryKey = (organizationId: ListAllHerdsForOfflinePathParams["organizationId"] | undefined, params?: ListAllHerdsForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/herds/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllHerdsForOfflineQueryKey = ReturnType<typeof listAllHerdsForOfflineQueryKey>

export function listAllHerdsForOfflineQueryOptions(organizationId: ListAllHerdsForOfflinePathParams["organizationId"] | undefined, params?: ListAllHerdsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllHerdsForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllHerdsForOfflineQueryResponse, ResponseErrorConfig<ListAllHerdsForOffline400 | ListAllHerdsForOffline401 | ListAllHerdsForOffline403 | ListAllHerdsForOffline404 | ListAllHerdsForOffline409 | ListAllHerdsForOffline500>, ListAllHerdsForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllHerdsForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated herd dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/herds/all}
 */
export function useListAllHerdsForOffline<TData = ListAllHerdsForOfflineQueryResponse, TQueryData = ListAllHerdsForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllHerdsForOfflineQueryKey>(organizationId: ListAllHerdsForOfflinePathParams["organizationId"] | undefined, params?: ListAllHerdsForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllHerdsForOfflineQueryResponse, ResponseErrorConfig<ListAllHerdsForOffline400 | ListAllHerdsForOffline401 | ListAllHerdsForOffline403 | ListAllHerdsForOffline404 | ListAllHerdsForOffline409 | ListAllHerdsForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllHerdsForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllHerdsForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllHerdsForOffline400 | ListAllHerdsForOffline401 | ListAllHerdsForOffline403 | ListAllHerdsForOffline404 | ListAllHerdsForOffline409 | ListAllHerdsForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}